import {
  getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts,
  getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** パートナーの 3 文字コード */
  threeLetterCode: string;
  /** 利用企業 ID */
  clientId: number;
};

type ReturnType = {
  /** API レスポンス（useFetch の data をそのまま返す） */
  data: GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts200;
};

type IUseGetPartnerAdminsClientContractTerm = (args: Args) => ReturnType;

/**
 * パートナー管理者向け企業契約期間一覧取得フック
 *
 * - `partner_admins/clients/{clientId}/client_contracts` から一覧を取得して返す
 * - PartnerAdmin 用 API は内部金額（パートナー販売手数料・Leafea収益単価）を含まない
 * - Suspense を使用してデータを取得する
 * - data はそのまま返す。絞り込み・整形は呼び出し側（logics/converter）の責務
 */
export const useGetPartnerAdminsClientContractTerm: IUseGetPartnerAdminsClientContractTerm = ({
  threeLetterCode,
  clientId,
}) => {
  const { data } = useFetch<GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts200>(
    getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsKey(
      threeLetterCode,
      clientId
    ),
    () =>
      getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts(threeLetterCode, clientId),
    { suspense: true }
  );

  return { data };
};
